<!-- src/components/dashboard/tasks/TaskCardSection.vue
  FT-076: секция задач для карточек. Показывается ТОЛЬКО если у сущности есть задачи
  (иначе скрыта — создание идёт из иконки в шапке карточки). v-show (не v-if), чтобы
  вложенный TaskList всё равно смонтировался, сходил за задачами и заполнил счётчик. -->
<template>
  <div v-show="taskableId && hasTasks" class="task-card-section">
    <task-list :taskable-type="taskableType" :taskable-id="taskableId" />
    <v-divider class="mt-3" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TaskList from "./TaskList.vue";

export default {
  name: "TaskCardSection",
  components: { TaskList },
  props: {
    taskableType: { type: String, required: true },
    taskableId: { type: [String, Number], default: null },
  },
  computed: {
    ...mapState("tasks", { items: (s) => s.items }),
    hasTasks() { return this.items.length > 0; },
  },
};
</script>
